import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { isGreaterThanBreakpoint } from 'dpl/util/grid';
import { getShortDateString } from 'dpl/shared/utils/date';
import Icon from 'dpl/common/components/Icon';
import SmartImage from 'dpl/components/SmartImage';
import {
  ArticlePropTypes,
  HubPropTypes
} from 'dpl/prismic/utils/customPropTypes';
import { getArticlePath } from 'dpl/prismic/utils';
import RichText from 'dpl/prismic/components/RichText';
import ViewAllLink from 'dpl/prismic/components/ViewAllLink';

import goodDogPodLogoJpg from 'dpl/assets/good_dog_pod_logo.jpg';

export default function FeaturedPodcasts({ sliceData }) {
  const articlesWithData = sliceData.items.filter(
    ({ article }) => article.data
  );

  if (articlesWithData.length === 0) {
    return null;
  }

  let imageWidth = '120px';
  if (isGreaterThanBreakpoint('lg')) {
    imageWidth = '200px';
  } else if (isGreaterThanBreakpoint('md')) {
    imageWidth = '156px';
  }

  return (
    <div className="PrismicFeaturedPodcasts pv10 pv20-lg nt8 nt12-md nt14-lg bg-lightest-blue">
      <div className="container">
        <div className="tc">
          <p className="mb6 f4 fw-medium">Podcast</p>
          <div className="ph4 bb bw1 b--black mb8 mb12-lg dib" />
        </div>
        <div className="row">
          {articlesWithData.map(({ article }, idx) => (
            <div
              className={classnames('mb0-lg col-lg-6', {
                mb8: idx < articlesWithData.length - 1
              })}
              key={idx}
            >
              <a className="flex" href={getArticlePath(article)}>
                <div className="mr3 mr4-lg">
                  <SmartImage
                    className="f0"
                    height={imageWidth}
                    lazy
                    src={goodDogPodLogoJpg}
                    width={imageWidth}
                  />
                </div>
                <div>
                  {article.data.display_date && (
                    <p className="mb2 mb0-lg f2">
                      {getShortDateString(new Date(article.data.display_date))}
                    </p>
                  )}
                  {article.data.title && article.data.title.length > 0 && (
                    <p className="f4-lg fw-medium">
                      {RichText.asText(article.data.title)}
                    </p>
                  )}
                  {article.data.deck && article.data.deck.length > 0 && (
                    <p className="mb2 d-none d-lg-block f2">
                      {RichText.asText(article.data.deck)}
                    </p>
                  )}
                  <div className="flex align-items-center">
                    <div className="ph5 ph6-xl pv5 pv6-xl mr2 mr4-xl br-100 relative bg-purple white">
                      <Icon className="transform-center-all" name="play" />
                    </div>
                    <p className="f2 f3-lg fw-medium ttu ttn-l purple">
                      Listen now
                    </p>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
        {sliceData.primary.view_all_hub &&
          sliceData.primary.view_all_hub.id && (
            <div className="mt8 mt10-lg mt16-xl tc">
              <ViewAllLink hubPage={sliceData.primary.view_all_hub} />
            </div>
          )}
      </div>
    </div>
  );
}

FeaturedPodcasts.propTypes = {
  sliceData: PropTypes.shape({
    items: PropTypes.arrayOf(ArticlePropTypes.isRequired).isRequired,
    primary: PropTypes.shape({
      view_all_hub: HubPropTypes.isRequired
    }).isRequired
  }).isRequired
};
